import { MessageCenterContainer } from "@relode/core";
import { Redirect, Route, Switch } from "react-router-dom";

import { ClientMarketResearchFeature } from "../marketResearch/clientMarketResearchFeature";
import { Settings } from "../settings/settings";
import { features, isUserAllowed } from "./appFeatures";
import * as React from "react";

export const AppRoutes = () => (
    <Switch>
        {renderFeatureRoutes()}
        <Route path="/messages" component={MessageCenterContainer} />
        <Route path="/settings" component={Settings} />
        {/* market-research needs to be here to handle instance of client
        (not client admin) attempting to login from public marketResearch */}
        <Route
            path="/market-research"
            exact={true}
            component={ClientMarketResearchFeature}
        />
        <Redirect path="/" exact={true} to="/dashboard" />
    </Switch>
);

const renderFeatureRoutes = () =>
    features
        .filter(isUserAllowed)
        .map((f, i) => (
            <Route
                key={i}
                path={f.route}
                component={f.component}
                render={f.render}
                exact={f.exact}
            />
        ));
